import { AlarmDto, TimeSeriesData } from '@thingslog/repositories';

export const convertAlarmsToTimeSeries = (
  alarms: AlarmDto[],
  sensorIndex: number
): TimeSeriesData<number>[] => {
  return alarms
    .filter(
      (alarm: AlarmDto) => alarm.sensorIndex === sensorIndex && alarm.alarmType === 'ON_OFF_ALARM'
    )
    .map((alarm: AlarmDto) => ({
      timestamp: alarm.date ? new Date(alarm.date).getTime() : new Date().getTime(),
      value: alarm.value,
    }))
    .sort((a: TimeSeriesData<number>, b: TimeSeriesData<number>) => a.timestamp - b.timestamp);
};
